export enum ValuedType {
    YES = "Sí",
    NO = "No",
    DRAFT = "Borrador",
    VALIDATE = "Validado",
}
